import { mapState, mapActions } from "vuex";

export const layoutComputed = {
    ...mapState("layout", {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader,
    }),
};

export const authMethods = mapActions("auth", [
    "logIn",
    "logOut",
    "register",
    "resetPassword",
]);

export const layoutMethods = mapActions("layout", [
    "changeLayoutType",
    "changeLayoutWidth",
    "changeLeftSidebarType",
    "changeTopbar",
    "changeLoaderValue",
]);

export const userComputed = {
    ...mapState("users", { users: (state) => state.users }),
};
export const userMethods = mapActions("users", ["fetchUsers"]);

export const memberComputed = {
    ...mapState("members", { members: (state) => state.members }),
};
export const memberMethods = mapActions("members", [
    "fetchMembers",
    "filterMembers",
]);

export const accountbalanceComputed = {
    ...mapState("accountbalances", {
        accountbalances: (state) => state.accountbalances,
    }),
};
export const accountbalanceMethods = mapActions("accountbalances", [
    "fetchAccountBalances",
]);

export const applicantComputed = {
    ...mapState("applicants", { applicants: (state) => state.applicants }),
};
export const applicantMethods = mapActions("applicants", ["fetchApplicants"]);

export const countriesComputed = {
    ...mapState("countries", { countries: (state) => state.countries }),
};
export const countriesMethods = mapActions("countries", ["fetchCountries"]);

export const expenseCategoryComputed = {
    ...mapState("expensecategories", {
        expensecategories: (state) => state.expensecategories,
    }),
};
export const expenseCategoryMethods = mapActions("expensecategories", [
    "fetchExpensecategories",
]);

export const expenseItemComputed = {
    ...mapState("expenseitems", {
        expenseitems: (state) => state.expenseitems,
    }),
};
export const expenseItemMethods = mapActions("expenseitems", [
    "fetchExpenseitems",
]);

export const expenseComputed = {
    ...mapState("expenses", { expenses: (state) => state.expenses }),
};
export const expenseMethods = mapActions("expenses", ["fetchExpenses"]);

export const expensecartComputed = {
    ...mapState("expensecarts", {
        expensecarts: (state) => state.expensecarts,
    }),
};
export const expensecartMethods = mapActions("expensecarts", [
    "fetchExpenseCart",
]);

export const reportexpenseComputed = {
    ...mapState("reportexpenses", {
        reportexpenses: (state) => state.reportexpenses,
    }),
};
export const reportexpenseMethods = mapActions("reportexpenses", [
    "fetchReportExpense",
    "filterReportExpense",
]);

export const smsBundleComputed = {
    ...mapState("smsbundles", { smsbundles: (state) => state.smsbundles }),
};
export const smsBundleMethods = mapActions("smsbundles", ["fetchSmsBundles"]);

export const smsPurchasesComputed = {
    ...mapState("smspurchases", {
        smspurchases: (state) => state.smspurchases,
    }),
};
export const smsPurchasesMethods = mapActions("smspurchases", [
    "fetchSmsPurchases",
]);

export const paymentoptionComputed = {
    ...mapState("paymentoptions", {
        paymentoptions: (state) => state.paymentoptions,
    }),
};
export const paymentoptionMethods = mapActions("paymentoptions", [
    "fetchPaymentoptions",
]);

export const savingpackageComputed = {
    ...mapState("savingpackages", {
        savingpackages: (state) => state.savingpackages,
    }),
};
export const savingpackageMethods = mapActions("savingpackages", [
    "fetchSavingPackages",
]);

export const financialyearComputed = {
    ...mapState("financialyears", {
        financialyears: (state) => state.financialyears,
        currentFinancialYear: (state) => state.currentFinancialYear,
    }),
};
export const financialyearMethods = mapActions("financialyears", [
    "fetchFinancialYears",
]);

export const permissionComputed = {
    ...mapState("permissions", { permissions: (state) => state.permissions }),
};
export const permissionMethods = mapActions("permissions", [
    "fetchPermissions",
]);

export const roleComputed = {
    ...mapState("roles", { roles: (state) => state.roles }),
};
export const roleMethods = mapActions("roles", ["fetchRoles"]);

export const auditComputed = {
    ...mapState("audits", { audits: (state) => state.audits }),
};
export const auditMethods = mapActions("audits", [
    "fetchAudits",
    "filterAudits",
]);

export const profileComputed = {
    ...mapState("profiles", { profiles: (state) => state.profiles }),
};
export const profileMethods = mapActions("profiles", ["fetchProfile"]);

export const savingComputed = {
    ...mapState("savings", { savings: (state) => state.savings }),
};
export const savingMethods = mapActions("savings", [
    "fetchSavings",
    "filterSavings",
]);

export const membershipfeeComputed = {
    ...mapState("membershipfees", {
        membershipfees: (state) => state.membershipfees,
    }),
};
export const membershipfeeMethods = mapActions("membershipfees", [
    "fetchMembershipFees",
    "filterMembershipFees",
]);

export const registrationfeeComputed = {
    ...mapState("registrationfees", {
        registrationfees: (state) => state.registrationfees,
    }),
};
export const registrationfeeMethods = mapActions("registrationfees", [
    "fetchRegistrationFees",
    "filterRegistrationFees",
]);

export const shareComputed = {
    ...mapState("shares", { shares: (state) => state.shares }),
};
export const shareMethods = mapActions("shares", [
    "fetchShares",
    "filterShares",
]);

export const withdrawComputed = {
    ...mapState("withdraws", { withdraws: (state) => state.withdraws }),
};
export const withdrawMethods = mapActions("withdraws", [
    "fetchWithdraws",
    "filterWithdraws",
]);

export const transactionComputed = {
    ...mapState("transactions", {
        transactions: (state) => state.transactions,
    }),
};
export const transactionMethods = mapActions("transactions", [
    "fetchTransactions",
    "filterTransactions",
]);

export const withdrawchargeComputed = {
    ...mapState("withdrawcharges", {
        withdrawcharges: (state) => state.withdrawcharges,
    }),
};
export const withdrawchargeMethods = mapActions("withdrawcharges", [
    "fetchWithdrawCharges",
    "filterWithdrawCharges",
]);

export const loanproductComputed = {
    ...mapState("loanproducts", {
        loanproducts: (state) => state.loanproducts,
    }),
};
export const loanproductMethods = mapActions("loanproducts", [
    "fetchLoanProducts",
]);

export const loanchargeComputed = {
    ...mapState("loancharges", { loancharges: (state) => state.loancharges }),
};
export const loanchargeMethods = mapActions("loancharges", [
    "fetchLoanCharges",
]);

export const loanapplicationComputed = {
    ...mapState("loanapplications", {
        loanapplications: (state) => state.loanapplications,
    }),
};
export const loanapplicationMethods = mapActions("loanapplications", [
    "fetchLoanApplications",
    "filterLoanApplications",
]);

export const loandisbursementComputed = {
    ...mapState("loandisbursements", {
        loandisbursements: (state) => state.loandisbursements,
    }),
};
export const loandisbursementMethods = mapActions("loandisbursements", [
    "fetchLoanDisbursements",
    "filterLoanDisbursements",
]);

export const runningloanComputed = {
    ...mapState("runningloans", {
        runningloans: (state) => state.runningloans,
    }),
};
export const runningloanMethods = mapActions("runningloans", [
    "fetchRunningLoans",
    "filterRunningLoans",
]);

export const closedloanComputed = {
    ...mapState("closedloans", { closedloans: (state) => state.closedloans }),
};
export const closedloanMethods = mapActions("closedloans", [
    "fetchClosedLoans",
    "filterClosedLoans",
]);

export const loanarrearComputed = {
    ...mapState("loanarrears", { loanarrears: (state) => state.loanarrears }),
};
export const loanarrearMethods = mapActions("loanarrears", [
    "fetchLoanArrears",
    "filterLoanArrears",
]);

export const writtenoffloanComputed = {
    ...mapState("writtenoffloans", {
        writtenoffloans: (state) => state.writtenoffloans,
    }),
};
export const writtenoffloanMethods = mapActions("writtenoffloans", [
    "fetchWrittenOffLoans",
    "filterWrittenOffLoans",
]);

export const dueloanComputed = {
    ...mapState("dueloans", { dueloans: (state) => state.dueloans }),
};
export const dueloanMethods = mapActions("dueloans", [
    "fetchDueLoans",
    "filterDueLoans",
]);

export const reportsavingpermemberComputed = {
    ...mapState("reportsavingpermembers", {
        reportsavingpermembers: (state) => state.reportsavingpermembers,
    }),
};
export const reportsavingpermemberMethods = mapActions(
    "reportsavingpermembers",
    ["fetchReportSavingsPerMember", "filterReportSavingsPerMember"],
);

export const reportsavingperuserComputed = {
    ...mapState("reportsavingperusers", {
        reportsavingperusers: (state) => state.reportsavingperusers,
    }),
};
export const reportsavingperuserMethods = mapActions("reportsavingperusers", [
    "fetchReportSavingsPerUser",
    "filterReportSavingsPerUser",
]);

export const reportwithdrawspermemberComputed = {
    ...mapState("reportwithdrawspermembers", {
        reportwithdrawspermembers: (state) => state.reportwithdrawspermembers,
    }),
};
export const reportwithdrawspermemberMethods = mapActions(
    "reportwithdrawspermembers",
    ["fetchReportWithdrawsPerMember", "filterReportWithdrawsPerMember"],
);

export const reportwithdrawsperuserComputed = {
    ...mapState("reportwithdrawsperusers", {
        reportwithdrawsperusers: (state) => state.reportwithdrawsperusers,
    }),
};
export const reportwithdrawsperuserMethods = mapActions(
    "reportwithdrawsperusers",
    ["fetchReportWithdrawsPerUser", "filterReportWithdrawsPerUser"],
);

export const reportsharepermemberComputed = {
    ...mapState("reportsharepermembers", {
        reportsharepermembers: (state) => state.reportsharepermembers,
    }),
};
export const reportsharepermemberMethods = mapActions("reportsharepermembers", [
    "fetchReportSharesPerMember",
    "filterReportSharesPerMember",
]);

export const reportshareperuserComputed = {
    ...mapState("reportshareperusers", {
        reportshareperusers: (state) => state.reportshareperusers,
    }),
};
export const reportshareperuserMethods = mapActions("reportshareperusers", [
    "fetchReportSharesPerUser",
    "filterReportSharesPerUser",
]);

export const reportsavingsbymonthComputed = {
    ...mapState("reportsavingsbymonths", {
        reportsavingsbymonths: (state) => state.reportsavingsbymonths,
    }),
};
export const reportsavingsbymonthMethods = mapActions("reportsavingsbymonths", [
    "fetchReportSavingsbyMonths",
    "filterReportSavingsbyMonths",
]);

export const reportmemberfeesComputed = {
    ...mapState("reportmemberfeespermembers", {
        reportmemberfeespermembers: (state) => state.reportmemberfeespermembers,
    }),
};
export const reportmemberfeesMethods = mapActions(
    "reportmemberfeespermembers",
    ["fetchReportMemberfees", "filterReportMemberfees"],
);

export const reportwithdrawsbymonthComputed = {
    ...mapState("reportwithdrawsbymonths", {
        reportwithdrawsbymonths: (state) => state.reportwithdrawsbymonths,
    }),
};
export const reportwithdrawsbymonthMethods = mapActions(
    "reportwithdrawsbymonths",
    ["fetchReportWithdrawsbyMonths", "filterReportWithdrawsbyMonths"],
);

export const reportsharesbymonthComputed = {
    ...mapState("reportsharesbymonths", {
        reportsharesbymonths: (state) => state.reportsharesbymonths,
    }),
};
export const reportsharesbymonthMethods = mapActions("reportsharesbymonths", [
    "fetchReportSharesbyMonths",
    "filterReportSharesbyMonths",
]);

export const reportloansbymonthComputed = {
    ...mapState("reportloansbymonths", {
        reportloansbymonths: (state) => state.reportloansbymonths,
    }),
};
export const reportloansbymonthMethods = mapActions("reportloansbymonths", [
    "fetchReportLoansbyMonths",
    "filterReportLoansbyMonths",
]);

export const reportloanpermemberComputed = {
    ...mapState("reportloanpermembers", {
        reportloanpermembers: (state) => state.reportloanpermembers,
    }),
};
export const reportloanpermemberMethods = mapActions("reportloanpermembers", [
    "fetchReportLoansPerMember",
    "filterReportLoansPerMember",
]);

export const reportloanperuserComputed = {
    ...mapState("reportloanperusers", {
        reportloanperusers: (state) => state.reportloanperusers,
    }),
};
export const reportloanperuserMethods = mapActions("reportloanperusers", [
    "fetchReportLoansPerUser",
    "filterReportLoansPerUser",
]);

export const reportloanperproductComputed = {
    ...mapState("reportloanperproducts", {
        reportloanperproducts: (state) => state.reportloanperproducts,
    }),
};
export const reportloanperproductMethods = mapActions("reportloanperproducts", [
    "fetchReportLoansPerProduct",
    "filterReportLoansPerProduct",
]);

export const reportloanpaymentComputed = {
    ...mapState("reportloanpayments", {
        reportloanpayments: (state) => state.reportloanpayments,
    }),
};
export const reportloanpaymentMethods = mapActions("reportloanpayments", [
    "fetchReportLoansPayment",
    "filterReportLoansPayment",
]);

export const reportcashflowComputed = {
    ...mapState("reportcashflows", {
        reportcashflows: (state) => state.reportcashflows,
    }),
};
export const reportcashflowMethods = mapActions("reportcashflows", [
    "fetchReportCashflow",
    "filterReportCashflow",
]);

export const reportinactivememberComputed = {
    ...mapState("reportinactivemembers", {
        reportinactivemembers: (state) => state.reportinactivemembers,
    }),
};
export const reportinactivememberMethods = mapActions("reportinactivemembers", [
    "fetchReportInactiveMembers",
    "filterReportInactiveMembers",
]);

export const investmentComputed = {
    ...mapState("investments", { investments: (state) => state.investments }),
};
export const investmentMethods = mapActions("investments", [
    "fetchInvestments",
]);

export const investmentreturnComputed = {
    ...mapState("investmentreturns", {
        investmentreturns: (state) => state.investmentreturns,
    }),
};
export const investmentreturnMethods = mapActions("investmentreturns", [
    "fetchInvestmentReturns",
    "filterInvestmentReturns",
]);

export const dividendpayoutComputed = {
    ...mapState("dividendpayouts", {
        dividendpayouts: (state) => state.dividendpayouts,
    }),
};
export const dividendpayoutMethods = mapActions("dividendpayouts", [
    "fetchDividendPayouts",
    "filterDividendPayouts",
]);

export const shareholderdividendComputed = {
    ...mapState("shareholderdividends", {
        shareholderdividends: (state) => state.shareholderdividends,
    }),
};
export const shareholderdividendMethods = mapActions("shareholderdividends", [
    "fetchShareHolderDividend",
]);

export const interestpayoutComputed = {
    ...mapState("interestpayouts", {
        interestpayouts: (state) => state.interestpayouts,
    }),
};
export const interestpayoutMethods = mapActions("interestpayouts", [
    "fetchInterestPayouts",
    "filterInterestPayouts",
]);

export const memberinterestComputed = {
    ...mapState("memberinterests", {
        memberinterests: (state) => state.memberinterests,
    }),
};
export const memberinterestMethods = mapActions("memberinterests", [
    "fetchMemberInterest",
]);

export const subscriptionComputed = {
    ...mapState("subscriptions", {
        subscriptions: (state) => state.subscriptions,
    }),
};
export const subscriptionMethods = mapActions("subscriptions", [
    "fetchSubscriptions",
]);

export const payoutrequestComputed = {
    ...mapState("payoutrequests", {
        payoutrequests: (state) => state.payoutrequests,
    }),
};
export const payoutrequestMethods = mapActions("payoutrequests", [
    "fetchPayoutRequests",
    "filterPayoutRequests",
]);

export const onlineTransactionComputed = {
    ...mapState("onlinetransactions", {
        onlinetransactions: (state) => state.onlinetransactions,
        withdrawnAmount: (state) => state.withdrawnAmount,
    }),
};
export const onlineTransactionMethods = mapActions("onlinetransactions", [
    "fetchOnlineTransactions",
]);

export const checkoffCartComputed = {
    ...mapState("checkoffcarts", {
        checkoffcarts: (state) => state.checkoffcarts,
    }),
};
export const checkoffCartMethods = mapActions("checkoffcarts", [
    "fetchCheckoffCarts",
]);

export const checkoffListComputed = {
    ...mapState("checkofflists", {
        checkofflists: (state) => state.checkofflists,
    }),
};
export const checkoffListMethods = mapActions("checkofflists", [
    "fetchCheckoffLists",
]);

export const contributionComputed = {
    ...mapState("contributions", {
        contributions: (state) => state.contributions,
    }),
};
export const contributionMethods = mapActions("contributions", [
    "fetchContributions",
]);

export const giveAwayComputed = {
    ...mapState("giveaways", { giveaways: (state) => state.giveaways }),
};
export const giveAwayMethods = mapActions("giveaways", ["fetchGiveAways"]);

export const creditReportComputed = {
    ...mapState("creditreports", {
        creditreports: (state) => state.creditreports,
    }),
};
export const creditReportMethods = mapActions("creditreports", [
    "fetchCreditReports",
]);

export const documentTypeComputed = {
    ...mapState("documenttypes", {
        documenttypes: (state) => state.documenttypes,
        loadingDocumentTypes: (state) => state.loadingDocumentTypes,
    }),
};
export const documentTypeMethods = mapActions("documenttypes", [
    "fetchDocumentTypes",
]);

export const documentComputed = {
    ...mapState("documents", {
        documents: (state) => state.documents,
        loadingDocuments: (state) => state.loadingDocuments,
    }),
};
export const documentMethods = mapActions("documents", ["fetchDocuments"]);

export const loanfinesComputed = {
    ...mapState("loanfines", { loanfines: (state) => state.loanfines }),
};
export const loanfinesMethods = mapActions("loanfines", ["fetchLoanFines"]);

export const crbReportsComputed = {
    ...mapState("crbreports", { crbreports: (state) => state.crbreports }),
};
export const crbReportsMethods = mapActions("crbreports", ["fetchCrbReports"]);
